import { DB } from '@tonic/central-specialties-utils';
import { useCallback, useEffect, useState } from 'react';
export const useMessages = (entityKind, entityId, pollInterval = 10000) => {
    const [initialFetchComplete, setInitialFetchComplete] = useState(false);
    const [messages, setMessages] = useState([]);
    const [isPending, setIsPending] = useState(false);
    const [isSyncing, setIsSyncing] = useState(false);
    const [sendIsPending, setSendIsPending] = useState(false);
    const [error, setError] = useState(null);
    const [sendError, setSendError] = useState(null);
    const fetchMessages = useCallback(async () => {
        // So they don't see a loading screen on poll, only on initialization
        if (!initialFetchComplete) {
            setIsPending(true);
        }
        else {
            setIsSyncing(true);
        }
        try {
            const messagesResponse = await DB.GET(`/${entityKind}/${entityId}/messages`);
            const receivedMessages = messagesResponse.data.messages;
            setError(null);
            setMessages(receivedMessages);
        }
        catch (e) {
            setError(e);
        }
        finally {
            if (!initialFetchComplete) {
                setInitialFetchComplete(true);
            }
            setIsPending(false);
            setIsSyncing(false);
        }
    }, [entityId, entityKind, initialFetchComplete]);
    const sendMessage = useCallback(async (message) => {
        setSendIsPending(true);
        try {
            const newMessageResponse = await DB.POST(`/${entityKind}/${entityId}/messages`, {
                body: {
                    message,
                },
            });
            const newMessage = newMessageResponse.data;
            setMessages([...messages, newMessage]);
            setSendError(null);
            // testMessages.push(newMessage);
            // await fetchMessages();
        }
        catch (e) {
            setSendError(e);
            throw e;
        }
        finally {
            setSendIsPending(false);
        }
    }, [entityKind, entityId, messages]);
    useEffect(() => {
        fetchMessages();
        const interval = setInterval(fetchMessages, pollInterval);
        return () => {
            clearInterval(interval);
        };
    }, [fetchMessages, pollInterval]);
    return {
        messages,
        sendMessage,
        isPending,
        sendIsPending,
        isSyncing,
        error,
        sendError,
    };
};
